import { GameManual } from '../../types';

export const vinhosDeluxeLegacyManualStub: GameManual = {
  chapters: [],
  firstGameSteps: [],
};
